import {
  GetImageUrlTypes,
  SizeGroupToDisplayType,
  ProductType,
  AdaptProductModelToggleType,
} from '../../../types';

const defaultPlacement = (sizeGroup: string) =>
  sizeGroup !== 'all' ? 'LAYDOWN' : false;

const getImageUrl = ({
  product,
  displayedSizeGroup,
  brandSizeGroups,
  selectedSizeGroup
}: GetImageUrlTypes) =>
  product.avImages?.[
    `${brandSizeGroups[displayedSizeGroup]?.placement}QuicklookImagePath`
  ] ||
  product.avImages?.[
    `${
      brandSizeGroups[<string>defaultPlacement(selectedSizeGroup)]?.placement
    }QuicklookImagePath`
  ] ||
  product.avImages?.p1QuicklookImagePath;

const sizeGroupToDisplay = ({
  brandSizeGroups,
  position,
  sizeGroup
}: SizeGroupToDisplayType) => {
  if (sizeGroup !== 'all') return sizeGroup;

  const sizeGroupsWithoutLaydown = Object.keys(brandSizeGroups).filter(
    sizeGroup => sizeGroup !== 'LAYDOWN'
  );
  const sizeGroupPosition = position % sizeGroupsWithoutLaydown.length;
  const sizeGroupToDisplay = sizeGroupsWithoutLaydown[sizeGroupPosition];
  return sizeGroupsWithoutLaydown.find(
    sizeGroup =>
      brandSizeGroups[sizeGroup].placement ===
      brandSizeGroups[sizeGroupToDisplay].placement
  );
};

const storeP1ImageOnProduct = (product: ProductType) => {
  if (product.avImages?.p1QuicklookImagePath) return product;
  const productClone = { ...product };
  productClone.avImages.p1QuicklookImagePath = product.url;
  return productClone;
};

export const adaptProductModelToggle = ({
  sizeGroup,
  product,
  position,
  brand,
  sizeGroups,
}: AdaptProductModelToggleType) => {
  const brandSizeGroups: {
    [key: string]: { placement: string; alpha?: string; numeric?: string };
  } = sizeGroups[brand];
  const productWithP1Stored = storeP1ImageOnProduct(product);
  const displayedSizeGroup = <string>sizeGroupToDisplay({
    brandSizeGroups,
    position,
    sizeGroup
  });
  return {
    ...productWithP1Stored,
    url: getImageUrl({
      product: productWithP1Stored,
      selectedSizeGroup: sizeGroup,
      displayedSizeGroup,
      brandSizeGroups
    }),
    modelSize: displayedSizeGroup
  };
};
